import { atom } from "recoil";

export const AgentApplicationsAtom = atom({
  key: "agent-applications-atom",
  default: [],
});
